"use client";

import { IS_BROWSER } from "@lib/constants";
import { useEffect, useState } from "react";

const getWidth = () => {
	if (IS_BROWSER) {
		return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	}

	return 0;
};

const useCurrentWidth = () => {
	const [width, setWidth] = useState(() => {
		// Initialize with 0 during SSR to prevent hydration mismatch
		return IS_BROWSER ? getWidth() : 0;
	});

	useEffect(() => {
		if (!IS_BROWSER) return;

		// Set the actual width on mount (client-side only)
		setWidth(getWidth());

		const resizeListener = () => {
			setWidth(getWidth());
		};

		window.addEventListener("resize", resizeListener);

		return () => {
			window.removeEventListener("resize", resizeListener);
		};
	}, []);

	return width;
};

export default useCurrentWidth;
